import { SortOrder } from "../../utils/sort/SortOrder";

export type SortedColumn<T> = T & {
    isSorted?: boolean;
    isSortedDescending?: boolean;
};

export interface ListTableSort {
    by: string;
    order: SortOrder;
}

export const sortColumns = <T extends { key: string }>(columns: T[], sort?: ListTableSort): T[] => {
    if (!sort) {
        return columns;
    }

    const columnToSort = columns.find((item) => item.key === sort.by);

    if (columnToSort) {
        return sortColumnsByOrder(columns, columnToSort, sort);
    }

    return columns;
};

const sortColumnsByOrder = <T>(columns: T[], columnToSort: T, sortBy: ListTableSort) => {
    const columnIndex = columns.indexOf(columnToSort);
    const modifiedColumn: SortedColumn<T> = {
        ...columnToSort,
        isSorted: true,
        isSortedDescending: sortBy.order === "desc"
    };

    return [...columns.slice(0, columnIndex), modifiedColumn, ...columns.slice(columnIndex + 1)];
};
